var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.22,
    height: 14.261,
    viewBox: "0 0 20.22 14.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97",
    "data-name": "Layer 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M25.809,23.622a1.735,1.735,0,0,1,.19,0l.122-1.016a2.372,2.372,0,0,0-.311-.017,3.172,3.172,0,0,0-3.169,3.186,2.421,2.421,0,0,0,.017.315l1.016-.129a1.67,1.67,0,0,1,0-.186,2.153,2.153,0,0,1,2.136-2.153Z",
    transform: "translate(-15.699 -18.645)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M6.64,22.829a18.669,18.669,0,0,1-3.223-3.112c.941-1.158,4.591-5.272,8.833-5.272a7.621,7.621,0,0,1,2.665.511l.356-.951a8.607,8.607,0,0,0-3.02-.576c-5.417,0-9.71,5.756-9.89,5.986l-.22.3.22.3a19.38,19.38,0,0,0,3.67,3.623Z",
    transform: "translate(-2.14 -12.587)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M27.96,17.769a19.38,19.38,0,0,0-3.67-3.623c-.3-.227-.62-.437-.938-.64L25.2,11.658l-.718-.718L10.94,24.483l.718.718,2.031-2.031a12.061,12.061,0,0,0,1.354.62,8.678,8.678,0,0,0,3.027.569c5.417,0,9.71-5.756,9.89-5.986l.22-.3Zm-7.747.115a1.67,1.67,0,0,1,0,.186,2.153,2.153,0,0,1-2.143,2.153h-.2a2.191,2.191,0,0,1-.914-.308l2.952-2.949a2.184,2.184,0,0,1,.308.918ZM18.07,23.342a7.662,7.662,0,0,1-2.661-.508c-.318-.122-.64-.264-.962-.423l1.771-1.771a3.125,3.125,0,0,0,1.541.582,2.369,2.369,0,0,0,.311,0A3.172,3.172,0,0,0,21.24,18.07a1.947,1.947,0,0,0,0-.295,3.149,3.149,0,0,0-.582-1.557l1.974-1.974c.362.223.721.457,1.067.714A18.669,18.669,0,0,1,26.9,18.07C25.963,19.228,22.313,23.342,18.07,23.342Z",
    transform: "translate(-7.961 -10.94)",
    fill: "#67E1AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideBalance);
export default __webpack_public_path__ + "static/media/hideBalance.6e8e03c91a1583ef724493ad7a538f40.svg";
export { ForwardRef as ReactComponent };